import { Paper, Typography } from "@mui/material";
import Layout from "../../components/Layout";
import { useT } from "../../i18n";
import EingangsrechnungenDataTable from "../../components/eingangsrechnungen/EIngangsrechnungenDataTable";
import ErrorAlert from "../../components/ErrorAlert";
import { notPermitted } from "../../errors";
import React from "react";
import Guard from "../../components/Guard";

export default function EingangsrechnungenListe() {
  const { t } = useT("customer");
  const limit = parseInt(
    localStorage.getItem("eingangsrechnungenLimit") ?? "25",
    10
  );
  return (
    <Layout title="Eingangsrechnungen" showTitleInNav={false}>
      <Guard
        permission={"eingangsrechnung:list"}
        fallback={<ErrorAlert error={notPermitted()} />}
      >
        <Paper
          elevation={1}
          sx={{ marginTop: 2, padding: 3, marginLeft: 2, marginRight: 2 }}
        >
          <Typography variant="h5">Eingangsrechnungen</Typography>
          <EingangsrechnungenDataTable limit={limit} />
        </Paper>
      </Guard>
    </Layout>
  );
}
